import $storage from '@/utils/storage'
import comefromConfig from './comefromConfig'
import { navigateTo } from './miniapp'
import { isMiniProgram } from '@/utils/tool'

// 第三方入口进来的标识
;(function() {
  // 获取入口标识，然后存储在store里面
  const comefrom = getUrlSpecifiedParam('comefrom') || sessionStorage.getItem('comefrom')
  const orgCode = getUrlSpecifiedParam('orgCode') || sessionStorage.getItem('orgCode')
  if (orgCode) {
    sessionStorage.setItem('orgCode', orgCode)
  }
  if (comefrom) {
    sessionStorage.setItem('comefrom', comefrom)
    // 存储comefrom跳转珍爱网首页
    if (getUrlSpecifiedParam('comefrom') === 'zhenai') {
      $storage.setItem({
        name: 'comefrom',
        value: comefrom,
        expires: 86400000
      })
    }
    if (['kangarooPhysicalSystem','pocketInfirmarySystem'].includes(comefrom)) {
      const isPerson = getUrlSpecifiedParam('isPerson')
      sessionStorage.setItem('isPerson', isPerson ? isPerson : '')
    }
  }
})()

function getUrlSpecifiedParam(paraName) {
  let url = document.location.toString()
  const replace = url.match(/#(\S*)\?/) // 获取#到？之间的一个数组
  replace && (url = url.replace(`#${replace[1]}?`, '?')) // 把url#后面的name值去掉，保留？后面的参数

  let arrObj = url.split('?')
  if (arrObj.length >= 3) {
    url = ''
    for (let i = 0, len = arrObj.length; i < len; i++) {
      url += i === 0 ? arrObj[0] + '?' : '&' + arrObj[i]
    }
    arrObj = url.split('?')
  }
  if (arrObj.length > 1) {
    const arrPara = arrObj[1].split(/[&#]/)
    let arr
    for (let i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split('=')
      if (arr != null && arr[0] == paraName) {
        return arr[1]
      }
    }
    return ''
  } else {
    return ''
  }
}

export function comefromLink(page) {
  if (!sessionStorage.getItem('comefrom') || !page) {
    return false
  }

  let comefrom = comefromConfig[sessionStorage.getItem('comefrom')]
  if (!comefrom || !comefrom.type) return false

  switch (comefrom.type) {
    case 'wx-miniapp':
      // 微信小程序跳转
      if(isMiniProgram()){
        navigateTo(comefrom[page])
      }
      // 普通web
      if(!isMiniProgram()){
        window.location.replace(comefrom['webHome'])
      }
      break
    default:
      // 普通h5跳转
      window.location.replace(comefrom[page])
  }
  return true
}
